import type { FormEvent, KeyboardEvent, RefObject } from 'react'
import type { AssessmentResponse, MaintenanceEvent } from '~/api/types'
import { AnalysisMessages } from './analysis-messages'
import { ChangeInputForm } from './change-input-form'
import type {
    MaintenanceProgress,
    PendingClarification,
    ResultItem,
} from './types'

/** 유지하기 분석의 중앙 대화 메시지와 입력 폼을 조립한다. */
export function AnalysisConversationPanel({
    assessments,
    selectedId,
    selectedAssessment,
    description,
    submittedText,
    pendingClarification,
    progress,
    actionError,
    submitting,
    textareaRef,
    activeEvent,
    history,
    resultItems,
    checklistCount,
    onSelectAssessment,
    onDescriptionChange,
    onSubmit,
    onDescriptionKeyDown,
    onSubmitClarification,
    onSelectImpact,
    onCopyRecheckItems,
    onOpenReport,
}: {
    assessments: AssessmentResponse[]
    selectedId: string
    selectedAssessment?: AssessmentResponse
    description: string
    submittedText: string | null
    pendingClarification: PendingClarification | null
    progress: MaintenanceProgress | null
    actionError: string | null
    submitting: boolean
    textareaRef: RefObject<HTMLTextAreaElement | null>
    activeEvent: MaintenanceEvent | null
    history: MaintenanceEvent[] | null
    resultItems: ResultItem[]
    checklistCount: number
    onSelectAssessment(value: string): void
    onDescriptionChange(value: string): void
    onSubmit(e: FormEvent<HTMLFormElement>): void
    onDescriptionKeyDown(e: KeyboardEvent<HTMLTextAreaElement>): void
    onSubmitClarification(combined: string): void
    onSelectImpact(itemId: string): void
    onCopyRecheckItems(): void
    onOpenReport(opts?: { print?: boolean }): void
}) {
    return (
        <section
            className='border-border bg-background flex min-h-0 min-w-0 flex-col overflow-hidden rounded-md border'
            aria-label='변경 영향 분석 대화'>
            <div className='min-h-0 flex-1 overflow-y-auto p-4'>
                <AnalysisMessages
                    activeEvent={activeEvent}
                    history={history}
                    submittedText={submittedText}
                    pendingClarification={pendingClarification}
                    progress={progress}
                    resultItems={resultItems}
                    checklistCount={checklistCount}
                    onSelectImpact={onSelectImpact}
                    onCopyRecheckItems={onCopyRecheckItems}
                    onOpenReport={onOpenReport}
                />
            </div>

            <ChangeInputForm
                assessments={assessments}
                selectedId={selectedId}
                selectedAssessment={selectedAssessment}
                description={description}
                pendingClarification={pendingClarification}
                followUpMode={Boolean(activeEvent && !pendingClarification)}
                actionError={actionError}
                submitting={submitting}
                textareaRef={textareaRef}
                onSelectAssessment={onSelectAssessment}
                onDescriptionChange={onDescriptionChange}
                onSubmit={onSubmit}
                onDescriptionKeyDown={onDescriptionKeyDown}
                onSubmitClarification={onSubmitClarification}
            />
        </section>
    )
}
